import React, { useState, useEffect } from "react";
import PageBanner from "../components/PageBanner";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Col, Row } from "antd";
import { FaTimes } from "react-icons/fa";

const CATI = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const [toggle, setToggle] = useState();
  const [toggle1, setToggle1] = useState();

  const handletoggle = () => {
    setToggle(!toggle);
  };
  const handletoggle1 = () => {
    setToggle1(!toggle1);
  };

  const cancletoggle = () => {
    setToggle(false);
    setToggle1(false);
  };

  const bannerData = {
    image: "/images/services/cati-banner.jpg",
    heading: "Computer-Assisted Telephonic Interviews",
    para: "In the dynamic field of market research, staying ahead is crucial for businesses aiming to grasp consumer behaviors and trends. This article explores the significance of Computer-Assisted Telephonic Interviews (CATI) as a valuable research tool.",
  };
  return (
    <div className="page-content">
      <Helmet>
        <title>CATI Services - Enhanced Market Research | Poll Sphere</title>
        <meta
          name="description"
          content="Explore Poll Sphere's Computer Assisted Telephone Interviewing (CATI) services for precise and efficient market research. Our expert team employs advanced telephonic methodologies to gather detailed insights, ensuring high response rates and accurate data collection. Perfect for understanding consumer behavior, gauging market trends, and driving business strategies. Experience seamless integration of technology and expertise with Poll Sphere's CATI solutions, tailored to meet your research objectives."
        />
      </Helmet>
      <PageBanner {...bannerData} />

      <section className="py-50">
        <div className="container">
          <Row align="middle" className="content-main-wrapper wrap-revers">
            <Col lg={12}>
              <div className="content-wrapper ">
                <h2> What is computer-Assisted Telephonic Interviews (CATI)</h2>
                <p>
                  Computer-Assisted Telephonic Interviewing, or CATI, is a
                  methodological approach used to conduct surveys and collect
                  data over the telephone. This technique blends the traditional
                  practice of telephone interviewing with modern technology to
                  streamline the data collection process, making it efficient,
                  accurate, and cost-effective.
                </p>
              </div>
            </Col>
            <Col lg={12} md={24}>
              <div className="img-wrapper">
                <img src="images/services/cati.jpg" alt="" />
              </div>
            </Col>
          </Row>
        </div>
      </section>

      <section>
        <div className="container-wrapper how-works ">
          <div className="img-wrapper">
            <img src="images/services/how-cati.jpg" alt="" />
          </div>
          <div className="text-wrapper">
            <div className="container">
              <Row align="middle">
                <Col md={12}>
                  <div className="content-wrapper">
                    <h2> How Does CATI Work?</h2>
                    <p>
                     
                    In a CATI interview, the interviewer uses a software program installed on a computer to display a structured questionnaire on the screen. This questionnaire is designed to be answered using pre-coded response options, which are also displayed on the screen.
                    </p>

                    <div
                      className={
                        toggle
                          ? "hide-content-wrapper show"
                          : "hide-content-wrapper "
                      }
                    >
                      <div className="container ">
                        <div className="hide-text">
                          <span onClick={cancletoggle} className="cancle-btn">
                            <FaTimes />{" "}
                          </span>

                          <h2> How Does CATI Work?</h2>
                          <p>
                            {" "}
                            <strong>Questionnaire Design : </strong>
                            Market researchers start by designing a structured
                            questionnaire that contains a series of questions
                            aimed at gathering specific information. These
                            questions can range from consumer preferences and
                            product feedback to political opinions and
                            demographic data.
                          </p>
                          <p>
                            {" "}
                            <strong>Database Management : </strong>A
                            well-maintained database of potential respondents is
                            crucial for CATI. Researchers select their target
                            audience based on criteria like age, location,
                            gender, or other relevant factors.
                          </p>
                          <p>
                            {" "}
                            <strong> Automated Calling : </strong>
                            CATI software automates the dialing process,
                            connecting interviewers with potential respondents.
                            This ensures that the survey reaches a diverse and
                            representative sample of the target population.
                          </p>
                          <p>
                            {" "}
                            <strong>Scripted Interviews : </strong>
                            During the CATI process, interviewers follow a
                            scripted questionnaire on their computer screens.
                            The software assists in asking questions, recording
                            responses, and managing the flow of the interview.
                            It can also prompt interviewers with skip patterns
                            or probes for more in-depth responses.
                          </p>
                          <p>
                            {" "}
                            <strong>Real-time Data Capture : </strong>
                            One of CATI's significant advantages is the
                            real-time data capture capability. As interviewers
                            enter responses, the data is instantly recorded and
                            can be analyzed immediately, allowing for quick
                            adjustments and insights.
                          </p>
                        </div>
                      </div>
                    </div>

                    <button onClick={handletoggle} className="btn btn-white">
                      Read More
                    </button>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </section>
      <section className="py-50">
        <div className="container-wrapper how-works ">
          <div className="img-wrapper">
            <img src="images/services/cati-benefits.jpg" alt="" />
          </div>
          <div className="text-wrapper">
            <div className="container">
              <Row align="middle">
                <Col md={12}>
                  <div className="content-wrapper">
                    <h2> Advantages of CATI</h2>
                    <p>
                      {" "}
                      <strong> Accuracy : </strong>
                      CATI ensures high data accuracy by reducing human errors
                      in data entry and transcription.
                    </p>
                    <div
                      className={
                        toggle1
                          ? "hide-content-wrapper show"
                          : "hide-content-wrapper "
                      }
                    >
                      <div className="container ">
                        <div className="hide-text">
                          <span onClick={cancletoggle} className="cancle-btn">
                            <FaTimes />{" "}
                          </span>

                          <h2> Advantages of CATI</h2>
                          <p>
                            {" "}
                            <strong> Accuracy : </strong>
                            CATI ensures high data accuracy by reducing human
                            errors in data entry and transcription.
                          </p>

                          <p>
                            {" "}
                            <strong>Efficiency : </strong>
                            It streamlines the interview process, making it
                            faster and more cost-effective compared to
                            traditional face-to-face interviews.
                          </p>
                          <p>
                            {" "}
                            <strong>Random Sampling : </strong>
                            The automated dialing system ensures a random and
                            representative sample of respondents, improving the
                            survey's reliability.
                          </p>
                          <p>
                            {" "}
                            <strong>Customization : </strong>
                            Researchers can customize surveys to specific
                            respondent segments, allowing for tailored questions
                            and more targeted insights.
                          </p>
                          <p>
                            {" "}
                            <strong>Real-time Monitoring :</strong>
                            CATI software allows for real-time monitoring of the
                            interview process, enabling researchers to address
                            issues and refine surveys as needed.
                          </p>

                          <p>
                            <strong>Data Security : </strong>
                            CAWI platforms prioritize data security and
                            confidentiality, safeguarding sensitive information.
                          </p>
                        </div>
                      </div>
                    </div>
                    <button onClick={handletoggle1} className="btn btn-white">
                      {" "}
                      Read More
                    </button>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </section>

      <section className="pb-50">
        <div className="container-wrapper how-works ">
          <div className="img-wrapper">
            <img src="images/services/cati-team.jpg" alt="" />
          </div>
          <div className="text-wrapper">
            <div className="container">
              <Row align="middle">
                <Col md={12}>
                  <div className="content-wrapper ">
                    <h2> Our CATI Team</h2>
                    <p>
                      Our CATI team at Poll Sphere is a dynamic group of
                      professionals highly proficient in conducting
                      telephone-based market research and online surveys. With
                      extensive experience and cutting-edge technology, they
                      ensure data accuracy and deliver actionable insights
                      across diverse industries. Their adaptability and
                      commitment to precision make them an invaluable asset to
                      our clients. From designing surveys to real-time data
                      capture, our CATI team is dedicated to providing
                      comprehensive, data-driven solutions for informed
                      decision-making.
                    </p>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </section>
      <section className="pb-50">
        <div className="container-wrapper how-works ">
          <div className="img-wrapper">
            <img src="images/services/B2B-cati.jpg" alt="" />
          </div>
          <div className="text-wrapper">
            <div className="container">
              <Row align="middle">
                <Col md={12}>
                  <div className="content-wrapper ">
                    <h2> Poll Sphere B2C (CATI)</h2>
                    <h4>
                      A Skilled and Experienced Team Ensuring Precise and
                      Trustworthy Data
                    </h4>
                    <p>
                      At Poll Sphere B2C (CATI), our team of seasoned CATI
                      professionals excels in delivering the utmost accuracy in
                      data collection. Our interviewers possess a polished and
                      engaging manner that allows them to adeptly manage a wide
                      range of interviews, captivating both respondents and
                      guests, thus enhancing the survey experience.
                    </p>

                    <p>
                      We systematically gather data from reputable sources,
                      using efficient methods, while our dedicated team ensures
                      optimal interview results through live recording, all
                      tracked conveniently via our user-friendly portal.
                    </p>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </section>
      <section className="pb-50">
        <div className="container-wrapper how-works ">
          <div className="img-wrapper">
            <img src="images/services/b2c-cati.jpg" alt="" />
          </div>
          <div className="text-wrapper">
            <div className="container">
              <Row align="middle">
                <Col md={12}>
                  <div className="content-wrapper ">
                    <h2> B2B (CATI)</h2>
                    <h4>
                      Experience Reliable B2B Interviewers and C-Level
                      Specialists with Poll Sphere's B2B CATI Service
                    </h4>
                    <p>
                      Poll Sphere's B2B research projects benefit from the
                      expertise of our professional interviewers, who play a
                      crucial role in ensuring high-quality results for business
                      operations. We've assembled a team of skilled CATI
                      professionals dedicated to conducting B2B interviews.
                    </p>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CATI;
